import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { VisibilityContextService } from '@app/core/services/visibility/visibility-context.service';
import { Observable } from 'rxjs';

@Injectable()
export class VisibilityIncerceptor implements HttpInterceptor {
  constructor(protected visibilityContextService: VisibilityContextService) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (request.url.includes('api')) {
      return next.handle(this.addVisibilityHeader(request));
    } else {
      return next.handle(request);
    }
  }

  addVisibilityHeader(request: HttpRequest<any>): HttpRequest<any> {
    return request.clone({
      setHeaders: {
        'VfS-Visibility-Enabled': JSON.stringify(this.visibilityContextService.isEnabled())
      }
    });
  }
}
